// extracted by mini-css-extract-plugin
export default {"errorCard":"errorCard_errorCard__oTK9R","errorTitle":"errorCard_errorTitle__Bl2oB","errorText":"errorCard_errorText__eqXqq"};